import { FC } from 'react';
import { Container, Stack, Typography } from '@mui/material';
import { IntroductionForm } from 'src/components/organisms/photo-studio/detail/introduction/form';
import Page from 'src/components/molecules/page';

export const IntroductionEditPage: FC = () => {
  const title = '店舗紹介編集';

  return (
    <Page title={title}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {title}
          </Typography>
        </Stack>
        <IntroductionForm />
      </Container>
    </Page>
  );
};
